/* ===========================
IMPORTS
=========================== */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
// IMPORT - ELEMENTS
import Loader from '../Elements/Loader';
import { IconSearch } from '../Elements/Icons';
// IMPORT - Helpers
import Helpers from '../../Helpers';

/* ===========================
CLASS
=========================== */
class ModalApk extends Component {
  /* ===========================
  DEFAULT
  =========================== */
  /**
   * Main constructor of Component
   */
  constructor(props) {
    super(props);

    this.state = {
      ids: [],
      data: [],
      meta: {},
      page: 1,
      limit: 250,
      search: '',
      loading: false,
      focus: null,
      errors: null,
    };

    this.get = this.get.bind(this);
    this.onClickNext = this.onClickNext.bind(this);
    this.onClickPrev = this.onClickPrev.bind(this);
    this.onSearchUpdate = this.onSearchUpdate.bind(this);
    this.onClickRow = this.onClickRow.bind(this);
    this.isSelected = this.isSelected.bind(this);
  }

  /**
   * componentDidMount
   */
  componentDidMount() {
    this.props.updateLoadingModal(false);
    this.setState({
      ids: this.props.data.apks.map((item) => item.id),
    });
    this.get();
  }

  /* ===========================
  FUNCTIONS
  =========================== */
  /**
   */
  searchTimeout = null;

  /**
   * @param {object} params
   * @param {function} callback
   * @param {function} failback
   */
  get(params, callback, failback) {
    this.setState({
      loading: true,
    }, () => {
      // Make initial request
      const defaultPayload = {
        page: this.state.page,
        limit: this.state.limit,
      };

      if (this.state.search && this.state.search.length > 0) {
        defaultPayload.search = this.state.search;
      }

      ModalApk.request(
        (params || defaultPayload),
        // callback
        (response) => {
          if (callback) {
            callback(response);
          } else if (response.apks) {
            this.setState({
              data: response.apks,
              meta: response.meta,
              loading: false,
            }, () => {
              // refocus on original input element
              if (this.state.focus) {
                document.getElementById(this.state.focus).focus();
              }
            });
          }
        },
        // failback
        (error) => {
          if (failback) {
            failback(error);
          } else {
            this.setState({
              errors: error,
              loading: false,
            });
          }
        },
      );
    });
  }

  /**
   * @param {object} params
   * @param {function} callback
   * @param {functin} failback
   */
  static request(params, callback, failback) {
    let query = '';
    if (params && Object.keys(params).length > 0) {
      Object.keys(params).map((key) => {
        query += `${key}=${params[key]}&`;
        return key;
      });
      query = `?${query}`;
    }

    Helpers.httpRequest(
      `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_VERSION}/apks${query}`,
      'get',
      null,
      // callback
      (response) => {
        if (callback) {
          callback(response);
        }
      },
      // failback
      (error) => {
        if (failback) {
          failback(error);
        }
      },
    );
  }

  /**
   * @param {object} payload
   * @param {function} callback
   * @param {function} failback
   */
  requestPut(payload, callback, failback) {
    Helpers.httpRequest(
      `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_VERSION}/bundles/${this.props.data.id}`,
      'put',
      JSON.stringify(payload),
      // callback
      (response) => {
        if (callback) {
          callback(response);
        }
      },
      // failback
      (error) => {
        if (failback) {
          failback(error);
        }
      },
    );
  }

  /**
   */
  onClickPrev() {
    this.setState((prevState) => ({
      page: prevState.page - 1,
    }), () => {
      this.get();
    });
  }

  /**
   */
  onClickNext() {
    this.setState((prevState) => ({
      page: prevState.page + 1,
    }), () => {
      this.get();
    });
  }

  /**
   * @param {Event} event
   */
  onSearchUpdate(event) {
    this.setState({
      search: event.target.value,
      focus: event.target.id,
    }, () => {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.get();
      }, 350);
    });
    event.preventDefault();
  }

  /**
   * @param {Event} event
   * @param {integer} id
   */
  onClickRow(event, id) {
    this.setState({
      errors: null,
    });

    this.props.handleSubmit(true);

    if (this.props.data.apks.length > 0 && this.isSelected(id)) {
      this.requestPut(
        {
          apk_ids: (this.props.data.apks.map((item) => {
            if (item.id !== id) {
              return item.id;
            }
            return null;
          }).filter((item) => item)),
        },
        // callback
        () => {
          this.props.handleSubmitSuccess();
        },
        // failback
        (error) => {
          this.setState({
            errors: error,
          }, () => {
            this.props.handleSubmit(false);
          });
        },
      );
    } else {
      this.requestPut(
        {
          apk_ids: [...(this.props.data.apks.map((item) => item.id)), id],
        },
        // callback
        () => {
          this.props.handleSubmitSuccess();
        },
        // failback
        (error) => {
          this.setState({
            errors: error,
          }, () => {
            this.props.handleSubmit(false);
          });
        },
      );
    }

    event.preventDefault();
  }

  /**
   * @param {integer} id
   */
  isSelected(id) {
    return (this.state.ids.indexOf(id) > -1);
  }

  /* ===========================
  RENDER
  =========================== */
  /**
   * Main table render
   */
  renderTable() {
    return (
      <div className="table-responsive">
        <table className="table table-bordered table-hover">
          <thead>
            <tr>
              <th>&nbsp;</th>
              <th>Apk Key</th>
            </tr>
          </thead>
          <tbody>
            {(this.state.loading)
              ? (<tr><td className="text-center" colSpan="2"><Loader /></td></tr>)
              : (
                <>
                  {(this.state.data.length > 0)
                    ? (this.state.data.map((row) => (
                      <tr key={`data-${row.id}`}>
                        <td>
                          {(this.props.data && this.isSelected(row.id))
                            ? (<button type="button" onClick={(e) => this.onClickRow(e, row.id)} disabled={this.props.submitted} className="btn btn-danger btn-block">{(this.props.submitted) ? '...' : (<i className="fa fa-close" />)}</button>)
                            : (<button type="button" onClick={(e) => this.onClickRow(e, row.id)} disabled={this.props.submitted} className="btn btn-success btn-block">{(this.props.submitted) ? '...' : (<i className="fa fa-check" />)}</button>)}
                        </td>
                        <td>{row.key}</td>
                      </tr>
                    )))
                    : (<tr><td colSpan="2">No Results</td></tr>)}
                </>
              )}
          </tbody>
        </table>
      </div>
    );
  }

  /**
   * Main render
   */
  render() {
    return (
      <div>
        {(!this.props.loading)
          ? (
            <div>
              {(this.state.errors && Object.keys(this.state.errors).length > 0)
                ? (
                  <div className="form-group">
                    <div className="alert alert-danger">
                      <ul>
                        {(Object.keys(this.state.errors).map((item) => (
                          <li key={`item-${item}`}>
                            <strong>{item}</strong>
                            {' '}
                            -
                            {' '}
                            {this.state.errors[item]}
                          </li>
                        )))}
                      </ul>
                    </div>
                  </div>
                )
                : null}

              {(this.props.data && this.props.data.apks && this.props.data.apks.length > 0)
                ? (
                  <div className="Tables-Current">
                    {(this.props.data.apks.map((item) => (
                      <div key={`row-${item.id}`} className="btn-group" role="group">
                        <button type="button" aria-label="click-row" onClick={(e) => this.onClickRow(e, item.id)} disabled={this.props.submitted || this.state.loading} className="btn btn-secondary"><i className="fa fa-close" /></button>
                        <button type="button" disabled={this.props.submitted || this.state.loading} className="btn btn-secondary">{item.key}</button>
                      </div>
                    )))}
                  </div>
                )
                : null}

              <div className="Tables">
                <div className="Tables-Search">
                  <div className="form-group">
                    <input id="Modal-Table-Search" onChange={this.onSearchUpdate} disabled={this.state.loading || this.props.submitted} type="search" className="form-control" placeholder="Search" value={this.state.search} />
                    <IconSearch />
                  </div>
                </div>
              </div>

              <div className="Tables-Control">
                <div className="row">
                  <div className="col col-12">
                    <div className="Tables-Control-Pagination float-left">
                      <div className="btn-group" role="group">
                        <button type="button" disabled={this.props.submitted || this.state.loading || this.state.data.length === 0 || this.state.page === 1} onClick={this.onClickPrev} className="btn btn-info">Prev</button>
                        <button type="button" disabled={this.props.submitted || this.state.loading || this.state.data.length === 0 || ((this.state.meta.total - (this.state.page * this.state.limit)) <= 0)} onClick={this.onClickNext} className="btn btn-info">Next</button>
                      </div>
                    </div>

                    {(!this.state.loading)
                      ? (
                        <div className="Tables-Control-Showing">
                          {(this.state.meta.total)
                            ? (
                              <span className="Tables-Control-Showing-Results">
                                Showing
                                {(this.state.data.length > 0)
                                  ? (((this.state.page - 1) * this.state.limit) + 1)
                                  : 0}
                                -
                                {((this.state.data.length > 0)
                                  // eslint-disable-next-line max-len
                                  ? (((this.state.page - 1) * this.state.limit) + this.state.data.length)
                                  : 0)}
                                {' '}
                                of
                                {this.state.meta.total}
                              </span>
                            )
                            : null}
                        </div>
                      )
                      : null}

                  </div>
                </div>
              </div>
              <div className="Tables-Data">
                {(this.renderTable())}
              </div>
            </div>
          )
          : ''}
      </div>
    );
  }
}

/* ===========================
PROPERTY TYPES
=========================== */
ModalApk.propTypes = {
  loading: PropTypes.bool,
  submitted: PropTypes.bool,
  updateLoadingModal: PropTypes.func,
  data: PropTypes.object,
  handleSubmit: PropTypes.func,
  handleSubmitSuccess: PropTypes.func,
};

/* ===========================
EXPORT
=========================== */
export default ModalApk;
